export const CTA_OPTIONS = [
  { value: "none", label: "Без кнопки" },
  { value: "call", label: "Позвонить" },
  { value: "contact", label: "Связаться" },
  { value: "write", label: "Написать" },
  { value: "go", label: "Перейти" },
  { value: "order", label: "Заказать" },
  { value: "learn_more", label: "Узнать больше" },
  { value: "get_discount", label: "Получить скидку" },
  { value: "try_free", label: "Попробовать бесплатно" },
];

export const BUSINESS_TYPES = [
  { value: "ecommerce", label: "Интернет-магазин" },
  { value: "services", label: "Услуги" },
  { value: "realty", label: "Недвижимость" },
  { value: "auto", label: "Авто" },
  { value: "restaurant", label: "Ресторан / кафе" },
  { value: "education", label: "Образование" },
  { value: "medicine", label: "Медицина" },
  { value: "beauty", label: "Красота и здоровье" },
  { value: "other", label: "Другое" },
];

export const COLOR_SCHEMES = [
  { value: "blue", label: "Синие тона" },
  { value: "red_orange", label: "Красные / оранжевые" },
  { value: "green", label: "Зелёные тона" },
  { value: "dark", label: "Тёмная, элегантная" },
  { value: "neutral", label: "Нейтральная, минимализм" },
  { value: "vivid", label: "Яркая, контрастная" },
];

export function buildSystemPrompt() {
  return `Ты — эксперт по созданию рекламных баннеров для таргетированной и программатик-рекламы.
Твоя задача — на основе данных о бренде и продукте составить детальный промпт на английском языке для генерации трёх вариантов рекламного баннера.

Требования к баннерам:
- Все тексты на баннерах — ТОЛЬКО на русском языке
- Дизайн чистый, современный, подходящий для интернет-рекламы
- Каждый вариант должен быть в отдельном стиле: minimal (белый фон, типографика), vivid (яркие цвета, контраст), premium (тёмный фон, роскошь)
- Баннер должен сразу привлекать внимание и побуждать к действию
- Соотношение сторон: 1200x628 px (landscape, для facebook/instagram/display)

Ответь ТОЛЬКО JSON-объектом без лишнего текста, по формату:
{
  "prompts": {
    "minimal": "...",
    "vivid": "...",
    "premium": "..."
  },
  "concept": "краткое описание концепции на русском"
}`;
}

export function buildUserPrompt(formData) {
  const ctaLabel = CTA_OPTIONS.find((o) => o.value === formData.ctaButton)?.label || "Перейти";
  const businessLabel = BUSINESS_TYPES.find((o) => o.value === formData.businessType)?.label || formData.businessType;
  const colorLabel = COLOR_SCHEMES.find((o) => o.value === formData.colorScheme)?.label || formData.colorScheme;
  const refUrls = formData.referenceImageDataUrls?.filter(Boolean) || [];
  const hasRefs = refUrls.length > 0;

  let prompt = `Бренд: ${formData.brandName}
Сфера: ${businessLabel}
Предложение/оффер: ${formData.offer}
Целевая аудитория: ${formData.targetAudience}
Заголовок баннера: ${formData.headline}
Цветовая гамма: ${colorLabel}
Кнопка CTA: ${ctaLabel}`;

  if (hasRefs) {
    prompt += `\nПользователь приложил ${refUrls.length} референс-изображени${refUrls.length === 1 ? "е" : refUrls.length < 5 ? "я" : "й"} (см. вложения). Используй палитру, настроение и композицию как ориентир для баннера; не копируй дословно, адаптируй под формат таргетированной рекламы. Не используй сайт клиента — выбраны только референсы.`;
  } else if (formData.websiteUrl?.trim()) {
    prompt += `\nСайт клиента (для стиля и изображений со страницы): ${formData.websiteUrl.trim()}`;
  }

  return prompt;
}

export function buildClaudeUserContent(formData) {
  const text = buildUserPrompt(formData);
  const refUrls = formData.referenceImageDataUrls?.filter((u) => typeof u === "string" && u.startsWith("data:image")) || [];
  if (refUrls.length === 0) return text;
  return [
    { type: "text", text },
    ...refUrls.slice(0, 3).map((url) => ({ type: "image_url", image_url: { url } })),
  ];
}
